import { useContext } from 'react';
import { PerformanceReportingContext } from './PerformanceReportingProvider';

export const usePerformanceReportingContext = () => {
  const context = useContext(PerformanceReportingContext);

  if (context === undefined) {
    throw new Error(
      'usePerformanceReportingContext must be used within a PerformanceReportingContext',
    );
  }

  return context;
};
